// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a701acef","453":"cc9fb8d8"}[chunkId] + ".chunk.js";
};